"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDisplayFormMapFromCatalog = exports.createDisplayFormMap = void 0;
var tslib_1 = require("tslib");
var objRefMap_1 = require("../metadata/objRefMap");
var flatMap_1 = tslib_1.__importDefault(require("lodash/flatMap"));
/**
 * Factory function that extracts all display forms from catalog entities and returns a map indexing display
 * form `ref` to display form metadata object.
 *
 * The lookups into the map can be done by any type of ObjRef.
 *
 * @param attributes - catalog attributes
 * @param dateDatasets - catalog date datasets
 * @param strictTypeChecking - indicate whether strict type checking should be done using 'type' property of input `idRef`; default is false - the type information will be ignored
 * @alpha
 */
function createDisplayFormMap(attributes, dateDatasets, strictTypeChecking) {
    if (strictTypeChecking === void 0) { strictTypeChecking = false; }
    var nonDateDisplayForms = flatMap_1.default(attributes, function (a) { return tslib_1.__spread(a.displayForms, a.geoPinDisplayForms); });
    var dateDisplayForms = flatMap_1.default(dateDatasets, function (d) {
        return flatMap_1.default(d.dateAttributes, function (a) { return a.attribute.displayForms; });
    });
    return objRefMap_1.newDisplayFormMap(tslib_1.__spread(nonDateDisplayForms, dateDisplayForms), strictTypeChecking);
}
exports.createDisplayFormMap = createDisplayFormMap;
/**
 * Factory function that extracts all display forms from workspace catalog and returns a map indexing
 * display form's `ref` to display form metadata object.
 *
 * The lookups into the map can be done by any type of ObjRef.
 *
 * @param catalog - workspace catalog
 * @param strictTypeChecking - indicate whether strict type checking should be done using 'type' property of input `idRef`; default is false - the type information will be ignored
 * @alpha
 */
function createDisplayFormMapFromCatalog(catalog, strictTypeChecking) {
    if (strictTypeChecking === void 0) { strictTypeChecking = false; }
    return createDisplayFormMap(catalog.attributes(), catalog.dateDatasets(), strictTypeChecking);
}
exports.createDisplayFormMapFromCatalog = createDisplayFormMapFromCatalog;
//# sourceMappingURL=displayFormMap.js.map